import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation or balance
 * rejection's reason survives to the form-level message rather than a generic one. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}
